import { render, staticRenderFns } from "./progressImpact.vue?vue&type=template&id=592f4a34"
import script from "./progressImpact.vue?vue&type=script&lang=js"
export * from "./progressImpact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports